import { screenSizes } from './screenSizes';
const { xs, sm, md, lg, xl } = screenSizes;
export const mediaSizes = {
    XsOnly: { maxWidth: xs.max },
    // xs down not needed - same as xs only
    XsUp: { minWidth: xs.min },
    SmOnly: { minWidth: sm.min, maxWidth: sm.max },
    SmDown: { maxWidth: sm.max },
    SmUp: { minWidth: sm.min },
    MdOnly: { minWidth: md.min, maxWidth: md.max },
    MdDown: { maxWidth: md.max },
    MdUp: { minWidth: md.min },
    LgOnly: { minWidth: lg.min, maxWidth: lg.max },
    LgDown: { maxWidth: lg.max },
    LgUp: { minWidth: lg.min },
    XlOnly: { minWidth: xl.min, maxWidth: xl.max },
    XlDown: { maxWidth: xl.max },
    // xl up not needed - same as xl only
};
export default mediaSizes;
//# sourceMappingURL=mediaSizes.js.map